module.exports = __webpack_public_path__ + "img/GCC.99a21c02.png";